import type { DiffLineType } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"


export function defaultDiffTheme(): DiffTheme {
  return {
    line: lineType => lineType ? defaultDiffLineTheme[lineType] : defaultDiffLineTheme.DEFAULT,
    gutter: lineType => lineType ? defaultDiffGutterTheme[lineType] : defaultDiffGutterTheme.DEFAULT,

    syntax: defaultSyntaxMarkupTheme,
  }
}

export type DiffTheme = {
  line: (lineType?: DiffLineType | null) => Property.Color
  gutter: (lineType?: DiffLineType | null) => Property.Color
  syntax: SyntaxMarkupTheme
}

export type DiffLineTheme = Record<DiffLineType | "DEFAULT", Property.Color>
export type DiffGutterTheme = Record<DiffLineType | "DEFAULT", Property.Color>
export type SyntaxMarkupTheme = Record<SyntaxMarkupMarker, Property.Color>

// TODO: DIFF_ADDITION and DIFF_DELETION probably should be removed from here
export type SyntaxMarkupMarker =
  | "HIGHLIGHT_BACKGROUND"
  | "HIGHLIGHT_TEXT"
  | "CURRENT_BACKGROUND"
  | "CURRENT_TEXT"
  | "COMMENT"
  | "NUM_LITERAL"
  | "STRING_LITERAL"
  | "KEYWORD"
  | "DECLARATION"
  | "PARAMETER_ASSIGNMENT"
  | "IDENTIFIER"
  | "INVOCATION"
  | "IDENTIFIER_TYPE"
  | "IDENTIFIER_DECLARATION"
  | "KEY"
  | "TAG"
  | "ANNOTATION"
  | "INLINE_ANNOTATION"
  | "PREPROCESSOR_ANNOTATION"
  | "PREPROCESSOR_MESSAGE"
  | "DIFF_ADDED"
  | "DIFF_DELETED"

export const defaultDiffLineTheme: DiffLineTheme = {
  ADDED: "var(--diff-line-added-color)",
  DELETED: "var(--diff-line-deleted-color)",
  MODIFIED: "var(--diff-line-modified-color)",
  FILTERED_MODIFIED: "var(--diff-line-modified-color)",
  CONFLICT_OLD: "var(--diff-line-conflict-color)",
  CONFLICT_NEW: "var(--diff-line-conflict-color)",

  FILTERED: "var(--diff-line-default-color)",
  FILTERED_ADDED: "var(--diff-line-default-color)",
  FILTERED_DELETED: "var(--diff-line-default-color)",

  DEFAULT: "var(--diff-line-default-color)",
}

export const defaultDiffGutterTheme: DiffGutterTheme = {
  ADDED: "var(--diff-gutter-added-color)",
  DELETED: "var(--diff-gutter-deleted-color)",
  MODIFIED: "var(--diff-gutter-modified-color)",
  FILTERED_MODIFIED: "var(--diff-gutter-modified-color)",
  CONFLICT_OLD: "var(--diff-gutter-conflict-color)",
  CONFLICT_NEW: "var(--diff-gutter-conflict-color)",

  FILTERED: "var(--diff-gutter-default-color)",
  FILTERED_ADDED: "var(--diff-gutter-default-color)",
  FILTERED_DELETED: "var(--diff-gutter-default-color)",

  DEFAULT: "var(--diff-gutter-default-color)",
}

export const defaultSyntaxMarkupTheme: SyntaxMarkupTheme = {
  HIGHLIGHT_BACKGROUND: "var(--syntax-marker-highlight-background-color)",
  HIGHLIGHT_TEXT: "var(--syntax-marker-highlight-text-color)",
  CURRENT_BACKGROUND: "var(--syntax-marker-current-background-color)",
  CURRENT_TEXT: "var(--syntax-marker-current-text-color)",
  COMMENT: "var(--syntax-marker-comment-color)",
  NUM_LITERAL: "var(--syntax-marker-num-literal-color)",
  STRING_LITERAL: "var(--syntax-marker-string-literal-color)",
  KEYWORD: "var(--syntax-marker-keyword-color)",
  DECLARATION: "var(--syntax-marker-declaration-color)",
  PARAMETER_ASSIGNMENT: "var(--syntax-marker-parameter-assignment-color)",
  IDENTIFIER: "var(--syntax-marker-identifier-color)",
  INVOCATION: "var(--syntax-marker-invocation-color)",
  IDENTIFIER_TYPE: "var(--syntax-marker-identifier-type-color)",
  IDENTIFIER_DECLARATION: "var(--syntax-marker-identifier-declaration-color)",
  KEY: "var(--syntax-marker-key-color)",
  TAG: "var(--syntax-marker-tag-color)",
  ANNOTATION: "var(--syntax-marker-annotation-color)",
  INLINE_ANNOTATION: "var(--syntax-marker-inline-annotation-color)",
  PREPROCESSOR_ANNOTATION: "var(--syntax-marker-preprocessor-annotation-color)",
  PREPROCESSOR_MESSAGE: "var(--syntax-marker-preprocessor-message-color)",
  DIFF_ADDED: "var(--syntax-marker-diff-added-color)",
  DIFF_DELETED: "var(--syntax-marker-diff-deleted-color)",
}